@use "../../styles/breakpoint.module" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: 1 / -1;
    position: relative;
    background-color: var(--color-primary, var(--salmon));

    --card-initial-width: 20vw;
    --card-initial-height: calc(var(--card-initial-width) * 4 / 3);

    @media ($below-tablet) {
        --card-initial-width: 223px;
        --card-initial-height: 297px;
    }

    @media ($below-mobile) {
        --card-initial-width: 164px;
        --card-initial-height: 219px;
    }
}

.content {
    grid-column: content;
    display: grid;
    grid-template-columns: subgrid;
    row-gap: var(--spacer-24);
    text-align: center;
    padding: var(--spacer-104) 0 var(--spacer-64) 0;
}

.title {
    grid-column: 1 / -1;
    color: var(--black);
    text-align: center;
    margin: 0;

    :where(p, h1, h2, h3, h4, h5, h6) {
        font: var(--font-ha-120);
        letter-spacing: -0.01em;
        margin: 0;
    }
}

.subtitle {
    grid-column: col-start 3 / col-end 10;
    color: var(--black);
    text-align: center;
    margin: 0;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }

    :where(p, h1, h2, h3, h4, h5, h6) {
        font: var(--font-sh-40);
        letter-spacing: -0.01em;
        margin: 0;
    }
}

.cta {
    grid-column: 1 / -1;
    justify-self: center;
}

.imageGridWrapper {
    grid-column: 1 / -1;
    position: relative;
    margin: 0;
    inset: 0;
    height: calc(var(--scroll-distance, 1000px) + 100vh);
    overflow-anchor: none;
}

.imageGridContainer {
    position: sticky;
    top: calc((100vh - var(--card-initial-height)) / 2);
    left: 0;
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    overflow: hidden;
    transform: translate3d(0, 0, 0);

    &.animating {
        top: calc(
            (100vh - var(--card-initial-height)) / 2 *
                (1 - var(--size-progress, 0))
        );
        height: calc(
            var(--card-initial-height) + (100vh - var(--card-initial-height)) *
                var(--size-progress, 0)
        );
    }
}

.imageGrid {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-24);
    height: 100%;
    width: 100%;
    flex: none;
}

.gridTile {
    position: relative;
    width: var(--card-initial-width);
    height: var(--card-initial-height);
    border-radius: var(--border-radius-md);
    background: var(--white);
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    background-position: 50% 50%;
    background-size: cover;
    flex: none;
    aspect-ratio: 2 / 3;
    min-width: calc(var(--card-initial-width) * 2 / 3);
    min-height: calc(var(--card-initial-height) * 2 / 3);

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.featuredCard {
    max-width: 100%;
    max-height: 100vh;
}

.animating .featuredCard {
    width: calc(
        var(--card-initial-width) + (100% - var(--card-initial-width)) *
            var(--size-progress, 0)
    );
    height: calc(
        var(--card-initial-height) + (100vh - var(--card-initial-height)) *
            var(--size-progress, 0)
    );
    border-radius: calc(
        var(--border-radius-md) *
            (1 - clamp(0, (var(--size-progress, 0) - 0.999) * 1000, 1))
    );
}

.animating .otherCard {
    width: calc(var(--card-initial-width) * (1 - var(--size-progress, 0)));
    height: calc(var(--card-initial-height) * (1 - var(--size-progress, 0)));
}

.mediaWrapper {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}
